import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge conditional class names and de-dupe conflicting Tailwind utilities
 * (e.g. `cn("px-2", cond && "px-4")` → `"px-4"`). The one class helper the
 * design system uses everywhere.
 */
export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}
